/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/google-services';

export const GoogleApi = {
  getCurrentLocation: async (body: FindLocationBody) => {
    let url = pathname;
    url += `/find-location`;

    try {
      return await entityService.post(url, body);
    } catch (error) {
      throw error;
    }
  },

  getCenterPointWard: async (body: any) => {
    let url = pathname;
    url += `/find-center-point-ward`;

    try {
      return await entityService.post(url, body);
    } catch (error) {
      throw error;
    }
  },

  getDetailAddressesByText: async (option: any) => {
    let url = pathname;
    const query = serialize(option);
    url += `/autocomplete${query}`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },

  getDetailAddressesByPlaceID: async (option: any) => {
    let url = pathname;
    const query = serialize(option);
    url += `/find-place-detail${query}`;

    try {
      return await entityService.get(url);
    } catch (error) {
      throw error;
    }
  },
};

interface FindLocationBody {
  latitude: number;
  longitude: number;
}
